module.exports = __webpack_public_path__ + "6d8452ce914943970518d1debd494bd0.png";